import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ErrorComponent } from './error/error.component';
import { ContentComponent } from './content/content.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { Common } from './global/common';



@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    ErrorComponent,
    ContentComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxSpinnerModule,
    
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    ErrorComponent,
    ContentComponent]
  ,
  providers: [Common]
})
export class SharedModule { }
